<template>
  <div>
    <!-- <span class="font-family-body">Operatore</span> -->
    <v-divider></v-divider>

    <div class="text-center w-100">
      <div class="chipContainer">
        <v-chip
          class="ma-2"
          color="blue"
          v-for="select in selected"
          :key="select.name"
          :v-model="select.name"
          :label="select.name"
          value="name"
          outlined
          @click="uncheck(select)"
        >
          {{ select.name }} {{ select.surname }}
        </v-chip>
      </div>

      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="operatore"
        item-key="name"
        show-select
        class="elevation-1"
      >
      </v-data-table>
<!-- 
      <div class="btnsContainer">
        <v-btn
          class="text-none"
          style="min-width: 88px"
          color="primary"
          depressed
          @click="$router.go(-1)"
        >
          Indietro
        </v-btn>

        <v-btn
          class="text-none"
          style="min-width: 88px"
          color="primary"
          depressed
          @click="$router.push({ name: 'formoperatore' })"
        >
          Avanti
        </v-btn>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selected: [],
      select: true,
      headers: [
        {
          text: "Nome",
          align: "start",
          sortable: false,
          value: "name",
        },
        { text: "Cognome", value: "surname" },
        { text: "Disponibilità", value: "availability" },
      ],
      operatore: [
        {
          name: "Pigna",
          surname: "Pi",
          availability: "Disponibile",
        },
        {
          name: "Daenerys",
          surname: "Targaryen",
          availability: "Disponibile",
        },
        {
          name: "Johnny",
          surname: "Bravo",
          availability: "Disponibile",
        },
        {
          name: "Zampy",
          surname: "El Gatto",
          availability: "Disponibile",
        },
        {
          name: "Pippo",
          surname: "Pips",
          availability: "Disponibile",
        },
        {
          name: "Zam",
          surname: "Burg",
          availability: "Disponibile",
        },
        {
          name: "Aby",
          surname: "By",
          availability: "Disponibile",
        },
      ],
    };
  },
  methods: {
    uncheck: function (select) {
      this.selected = this.selected.filter((name) => name !== select);
    },
  },
};
</script>

<style>
.btnsContainer {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}
.chipContainer {
  max-width: 560px;
}
</style>
